import React, { useState } from "react";
import { getStyle } from "../../../styles/styles";
import DynamicSelect from "../../shared/DynamicSelect";
import { formatValidSelect } from "../../../helpers/FormatHelper";
import { useEffect } from "react";
import { getBNVaults } from "../../../networking/NetworkingOrders";
import RealignItem from "./RealignItem";
import { getStockRealign, saveReasignStock } from "../../../networking/NetworkingBankNotes";
import AlertBox from "../../shared/AlertBox";
import { getRolesByUsername } from "../../../networking/NetworkingRoles";
import LoadingBox from "../../shared/LoadingBox";


const RealignDenominationsScreen = () => {
    const style = getStyle();
    const [vault, setVault] = useState(-1);
    const [vaultList, setVaultList] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [realignItems, setRealignItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showStock, setShowStock] = useState(false);
    const validations = {
        Vault: true
    }

    const BNRealign_Denominations = "BNRealignDenominations";

    useEffect(()=>{
        const loadVaultsAndCurrencies = async () => {
            setLoading(true);
            const jsonRoles = await getRolesByUsername('ForeignExchange', localStorage.getItem('UserName'));
                      if (jsonRoles && Array.isArray(jsonRoles) && jsonRoles.map(e => e.toLowerCase()).includes(BNRealign_Denominations.toLowerCase())) {
                        setShowStock(true)
                      }
                      else {
                        setShowStock(false)
                      }

            const json = await getBNVaults();

            if(json !== undefined && json.data) {
                const vaults = json.data.map((c) => ({...c, value: c.VaultID, name: c.Description}));
                vaults.splice(0,0,{value: -1, name: "Select a vault"});
                setVaultList(vaults);                
            }

            let currenciesList = JSON.parse(localStorage.getItem('Currencies'));
            if(currenciesList !== undefined) {
                currenciesList = currenciesList.map((c) => ({...c, value: c["Currency Id"], name: `${c["Currency Id"]} - ${c["Currency Name"]}`}));
                setCurrencies(currenciesList);
            }

            setLoading(false);
        }
        loadVaultsAndCurrencies();
    },[])

    const dropdownVaultChangeHandler = (value) =>{
        if(value && value.value)
        {
            setVault(value.value);
        }
    }

    const addCurrency = () =>{
        if(vault > 0)
        {
            const items = [...realignItems];
            items.push({ CurrencyID: "", ReportedValue: 0, TotalAmount:0 });
            setRealignItems(items);
        }
    }

    const valid = () =>{
        let isValid = true;
        realignItems.forEach(d => {
            if(d.TotalAmount !== d.ReportedValue)
            {
                isValid = false;
            }
        });
        return isValid;
    }

    const getListToSave = () =>{

        const userID=localStorage.getItem('UserID');

        const vaultBalances = [];

        realignItems.forEach(i => {
            i.Denominations.forEach(d => {

                vaultBalances.push({CurrencyID:i.CurrencyID, Denomination: d.DenominationDescription, Stock: (d.ReportedNoNotes?d.ReportedNoNotes: 0),
                    OriginalStock: (d.NoNotesInStock ? d.NoNotesInStock: 0)
                });
            })
        })

        return {
            VaultID: vault,
            UserID: userID,
            BNVaultBalances: vaultBalances
        }

    }

    const onSave = async() =>{
        if(realignItems.length> 0)
        {
            if(valid())
            {
                setLoading(true);
                const listToSave = getListToSave();

                const responseSave = await saveReasignStock(listToSave);
                setLoading(false);

                if(responseSave.httpStatusCode !== 200)
                {
                    setAlertTitle('Error');
                    setAlertMessage(responseSave.Message);
                    setShowAlert(true);
                }
                else{
                    setAlertTitle('Success');
                    setAlertMessage('The reassignment was successfully saved.');
                    setShowAlert(true);
                    clearAll();
                }
            }
            else
            {
                setAlertTitle('Error');
                setAlertMessage(`There are some differences.`);
                setShowAlert(true);
            }
        }
    }

    const loadCurrencyDenominations = async(currencyId, index) =>{

        const currencyDetails = await getStockRealign(vault, currencyId)
        
        let denominations = [];
        let total = 0;

        if (currencyDetails && currencyDetails.Denominations) {            
            denominations = currencyDetails.Denominations;
            
        if (Array.isArray(denominations) && denominations.length > 0) {
            denominations.forEach(d => {
                total += d.DenominationValue*d.NoNotesInStock
            });
        }
        }

         setRealignItems(prev => {
            const rows = [...prev];
            if(index > -1)
            {
                rows[index] = { ...rows[index],  CurrencyID: currencyId, Denominations: denominations, TotalAmount: total};
            }
            return rows;
        });
    }

    const removeItem = (item) => {
        const items = realignItems.filter(i => i.CurrencyID !== item.CurrencyID)
        setRealignItems(items)
    }

    const clearAll = () =>{
        setVault(-1);
        setRealignItems([]);
    }

    const validateCurrency = (ccy) =>{
        const existCCy = realignItems.filter(i => i.CurrencyID === ccy);
        if(existCCy && existCCy.length > 0 && existCCy[0].CurrencyID && existCCy[0].CurrencyID !== '')
        {
            setAlertTitle('Error');
            setAlertMessage(`${existCCy[0].CurrencyID} currency has already been used.`);
            setShowAlert(true);
            return true;
        } 
        else
        {
            return false;
        }
    }


    const getRecordView = ()=>{
        const recordView = [];
        if(realignItems && realignItems.length > 0)
        {
            realignItems.forEach(
                (item, index) => recordView.push(
                    <RealignItem key={index} item={item} index={index}
                        loadCurrencyDenominations={loadCurrencyDenominations}
                        currencies={currencies}
                        editingRow={item.Denominations !== undefined && item.Denominations.length > 0 && item.CurrencyID !== ''}
                        removeItem={removeItem}
                        enableRemove={true}
                        showStock={showStock}
                        validateCurrency={validateCurrency} />
                )
            );
        }
        
    return recordView
    }

    return <>
        <h3 className="uk-heading-divider" style={style.titleStyle} >{`Bank Notes - Realign Denominations`}</h3>
        <div className="uk-grid">
            <div className="uk-width-1-4">
                <div className="uk-margin">
                    <label className="uk-form-label" >Vault</label>
                    <DynamicSelect
                        className={formatValidSelect(validations.Vault)}
                        listHasPlaceholder={true}
                        data={vaultList}
                        objValue={{value:vault}}
                        getValue={dropdownVaultChangeHandler}
                        disabled={realignItems.length>0}/>         
                </div>
            </div>
            <div className="uk-width-1-4" style={{paddingTop:'15px'}}>
                    <button
                            id="rc-b-clear"
                        className="uk-button uk-button-green"
                        type="button"
                        onClick={clearAll}
                        disabled={loading}
                    >
                        Clear
                    </button>   
            </div>
        </div>
        <hr />
        <div style={{ display: 'flex', gap: '2rem', flexDirection: 'row' }}>
                {<button
                    id="rc-b-add-currency"
                    className="uk-button uk-button-green"
                    type="button"
                    onClick={addCurrency}
                    disabled={loading}
                >
                    Add Currency
                </button>}
                <button
                    id="rc-b-finalsubmit"
                    className="uk-button uk-button-green"
                    type="button"
                    onClick={onSave}
                    disabled={loading}>
                    Submit
                </button>
            </div>
            
            <div style={{marginTop:'20px'}}>{getRecordView()}</div>
            <AlertBox open={showAlert} onClose={()=> setShowAlert(false)} title={alertTitle} message={alertMessage} type="Ok" okClick={()=> setShowAlert(false)} />
            <LoadingBox loading={loading} />
    </>
}

export default RealignDenominationsScreen